// API Base URL from environment or default
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "https://us-central1-your-project.cloudfunctions.net";

// Function names (exported as REST endpoints from Cloud Functions)
export const FUNCTIONS = {
  GIFTCARDS_ISSUE: `${API_BASE_URL}/giftcards_issue`,
  WALLET_REDEEM: `${API_BASE_URL}/wallet_redeem`,
  WALLET_CLAIM: `${API_BASE_URL}/wallet_claim`,
  WALLET_PROJECTIONS: `${API_BASE_URL}/wallet_projections`,
  HEALTH_CHECK: `${API_BASE_URL}/healthCheck`,
};
